import React from 'react'
import PropTypes from 'prop-types'

import StormcloudButton from './../block/StormcloudButton'

import styles from './../style/Uslugi.module.scss'

import { Image } from 'react-bootstrap'

import FeedbackForm from './FeedbackForm'

class UslugiLastCard extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  render() {

    const { assets_path } = this.props,
    { show_feedback } = this.state

    return (
      <div className={styles.cards_elm_last}>
        <div className={styles.cards_elm_spcard}>
          <div className={styles.cards_elm_spcard_card}>
            <Image src={`/${assets_path}/images/like-tag.svg`} />
            <div>
              <div className={styles.cards_elm_spcard_card_name}>20 лет</div>
              <div>на рынке</div>
            </div>
          </div>
          <div className={styles.cards_elm_spcard_card_sep} />
          <div className={styles.cards_elm_spcard_card}>
            <Image src={`/${assets_path}/images/tag-user.svg`} />
            <div>
              <div className={styles.cards_elm_spcard_card_name}>4670</div>
              <div>довольных клиентов</div>
            </div>
          </div>
          <div className={styles.cards_elm_spcard_card_sep} />
          <div className={styles.cards_elm_spcard_card}>
            <Image src={`/${assets_path}/images/medal-star.svg`} />
            <div>
              <div className={styles.cards_elm_spcard_card_name}>От 12 лет</div>
              <div>опыт монтажников</div>
            </div>
          </div>
          <div className={styles.cards_elm_spcard_card_sep} />
          <div className={styles.cards_elm_spcard_card}>
            <Image src={`/${assets_path}/images/verify.svg`} />
            <div>
              <div className={styles.cards_elm_spcard_card_name}>5 лет</div>
              <div>гарантии</div>
            </div>
          </div>
          <div className={styles.cards_elm_spcard_card_sep} />
          <div className={styles.cards_elm_spcard_card}>
            <div>
              <div className={styles.cards_elm_spcard_card_name}>Нужна дополнительная информация?</div>
              <div className={styles.cards_elm_spcard_card_pline}>
                <div>Закажите звонок</div>
                <div className={styles.cards_elm_spcard_card_pline_sep} />
              </div>
            </div>
          </div>
          <StormcloudButton
            text={`Заказать звонок`}
            width={147}
            svg={
              <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.0918 7.90998L7.90998 1.0918M7.90998 1.0918H2.45543M7.90998 1.0918V6.54634" stroke="#3E4C5A" stroke-linecap="round"/>
              </svg>
            }
            className={styles.btn}
            action={() => this.showFeedback()}
          />
        </div>
        <FeedbackForm
          title={`Заказать звонок`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </div>
    )
  }
}

UslugiLastCard.propTypes = {
  assets_path: PropTypes.string
}

UslugiLastCard.defaultProps = {
  assets_path: 'assets'
}

export default UslugiLastCard